module.exports = __webpack_public_path__ + "img/组织-平面.3db02e41.png";